import type { ThemeOptions } from '@mui/material';

import { typography } from './typography';

export const chipComponent = {
  styleOverrides: {
    root: {
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '7px',
      ...typography.chip,
    },
  },
} as const satisfies NonNullable<ThemeOptions['components']>['MuiChip'];
